module.exports = __webpack_public_path__ + "img/study01.38a81392.png";